import { useState, useEffect, useCallback } from 'react';
import { useApiKey } from '../contexts/ApiKeyContext';

/**
 * Hook for managing the API key modal
 * 
 * This hook provides functions for managing the API key modal state and
 * handles showing the modal when no API key is set.
 * 
 * @returns {Object} An object containing modal state and functions
 */
export default function useApiKeyModal() {
  const { hasApiKey, setApiKey, clearApiKey, isLoading } = useApiKey();
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  // Function to open the modal
  const openModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);
  
  // Function to close the modal
  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);
  
  // Handle API key success
  const handleSuccess = useCallback((apiKey) => {
    console.log('API key set successfully');
    closeModal();
  }, [closeModal]);
  
  // Handle API key skip
  const handleSkip = useCallback(() => {
    console.log('User skipped entering API key');
    closeModal();
  }, [closeModal]);
  
  // Check for API key on mount and show modal if needed
  useEffect(() => {
    if (!isLoading && !hasApiKey()) {
      openModal();
    }
  }, [isLoading, hasApiKey, openModal]);
  
  return {
    isModalOpen,
    openModal,
    closeModal,
    handleSuccess,
    handleSkip,
    hasApiKey: hasApiKey(),
    setApiKey,
    clearApiKey,
  };
} 